"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Line = _interopRequireDefault(require("./Line"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Skeleton = function Skeleton(_ref) {
  var count = _ref.count,
      animated = _ref.animated,
      props = _objectWithoutProperties(_ref, ["count", "animated"]);

  var linesToRender = Array.apply(null, {
    length: count
  }).map(Number.call, Number);
  return _react["default"].createElement("div", {
    className: "react-skeletons__container"
  }, linesToRender.map(function (_, index) {
    return _react["default"].createElement(_Line["default"], {
      key: "react-skeletons-line-".concat(index),
      animated: animated
    });
  }));
};

Skeleton.defaultProps = {
  count: 3,
  animated: true
};
var _default = Skeleton;
exports["default"] = _default;